/* Adventskalender PLUS XXL – Newsletter-Pop-up (Section sp-adv-popup) */
(function () {
  var root = document.getElementById('spadv');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';

  var EN = root.dataset.lang === 'en';
  var DAY = 864e5;
  function store(k, v) {
    try { if (v === undefined) return window.localStorage.getItem(k); window.localStorage.setItem(k, v); } catch (e) { return null; }
  }
  function parse(s) { var p = String(s || '').split('-'); return new Date(+p[0], (+p[1] || 1) - 1, +p[2] || 1); }
  function addDays(d, n) { var x = new Date(d); x.setDate(x.getDate() + n); return x; }
  function weekday(d) { var g = d.getDay(); return g > 0 && g < 6; }
  function workdays(a, b) { var n = 0, x = new Date(a); while (x <= b) { if (weekday(x)) n++; x = addDays(x, 1); } return n; }
  function monday(d) { var g = d.getDay() || 7; return addDays(d, 1 - g); }

  var MDE = ['Januar','Februar','März','April','Mai','Juni','Juli','August','September','Oktober','November','Dezember'];
  var MEN = ['January','February','March','April','May','June','July','August','September','October','November','December'];
  var DDE = ['So','Mo','Di','Mi','Do','Fr','Sa'];
  var DEN = ['Sun','Mon','Tue','Wed','Thu','Fri','Sat'];

  var params = new URLSearchParams(window.location.search);
  var force = params.get('spadv') || root.dataset.force || 'auto';
  var posted = !!root.querySelector('[data-spadv-ok]');
  var failed = !!root.querySelector('[data-spadv-err]');
  if (force === 'success') posted = true;

  var start = parse(root.dataset.start), end = parse(root.dataset.end);
  var now = new Date();
  var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  if (force === 'pre') today = addDays(start, -5);
  if (force === 'live') today = addDays(start, 3);

  var state = today < start ? 'pre' : (today <= end ? 'live' : 'off');
  if (state === 'off' && !posted && !failed) return;
  root.dataset.state = state === 'off' ? 'live' : state;

  var total = workdays(start, end);
  function fmtDate(d) { return EN ? d.getDate() + ' ' + MEN[d.getMonth()].slice(0, 3) : d.getDate() + '.' + (d.getMonth() + 1) + '.'; }
  function set(sel, txt) { var els = root.querySelectorAll(sel); for (var i = 0; i < els.length; i++) els[i].textContent = txt; }

  set('[data-spadv-range]', EN
    ? start.getDate() + ' ' + MEN[start.getMonth()] + ' to ' + end.getDate() + ' ' + MEN[end.getMonth()]
    : start.getDate() + '. ' + MDE[start.getMonth()] + ' bis ' + end.getDate() + '. ' + MDE[end.getMonth()]);
  set('[data-spadv-total]', String(total));

  // Türchen der aktuellen Woche
  var base = state === 'pre' ? start : today;
  if (!weekday(base)) base = addDays(monday(base), 7);
  if (base > end) base = end;
  var mon = monday(base);
  var doors = root.querySelectorAll('.spadv__door');
  for (var i = 0; i < doors.length; i++) {
    var dd = addDays(mon, i), el = doors[i];
    el.className = 'spadv__door';
    if (dd < start || dd > end) { el.className += ' spadv__door--void'; continue; }
    var st = '';
    if (state === 'pre') { if (+dd === +start) { el.className += ' spadv__door--start'; st = 'Start'; } }
    else if (+dd === +today) { el.className += ' spadv__door--today'; st = EN ? 'Today' : 'Heute'; }
    else if (dd < today) { el.className += ' spadv__door--past'; }
    el.querySelector('.spadv__dday').textContent = (EN ? DEN : DDE)[dd.getDay()];
    el.querySelector('.spadv__dnum').textContent = String(workdays(start, dd));
    el.querySelector('.spadv__dstate').textContent = st || fmtDate(dd);
  }
  var weekNo = Math.round((mon - monday(start)) / (7 * DAY)) + 1;
  var weeks = Math.round((monday(end) - monday(start)) / (7 * DAY)) + 1;
  set('[data-spadv-week]', EN ? 'Week ' + weekNo + ' of ' + weeks : 'Woche ' + weekNo + ' von ' + weeks);

  var next = weekday(today) && state === 'live' ? today : addDays(monday(today), 7);
  var door = workdays(start, next);
  set('[data-spadv-door]', String(door));
  var liveTitle = root.querySelector('[data-spadv-live-title]');
  if (liveTitle && !(weekday(today) && state === 'live')) {
    liveTitle.textContent = EN ? 'Door ' + door + ' opens on Monday' : 'Montag öffnet Türchen ' + door;
  }

  // Ansicht
  var vForm = root.querySelector('[data-spadv-view="form"]');
  var vOk = root.querySelector('[data-spadv-view="success"]');
  if (posted) { vForm.hidden = true; vOk.hidden = false; store('spadv-sub', '1'); }

  // Öffnen und Schließen
  var dialog = root.querySelector('.spadv__dialog');
  var lastFocus = null, isOpen = false, timer = null;
  function focusables() { return dialog.querySelectorAll('a[href],button:not([disabled]),input:not([type="hidden"]),select'); }
  function open() {
    if (isOpen) return;
    isOpen = true; clearTimeout(timer);
    lastFocus = document.activeElement;
    root.hidden = false;
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    var first = posted ? root.querySelector('.spadv__x') : root.querySelector('.spadv__input');
    setTimeout(function () { if (first) first.focus({ preventScroll: true }); }, 60);
    document.addEventListener('keydown', onKey);
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('is-open');
    store('spadv-x', String(Date.now()));
    setTimeout(function () { root.hidden = true; }, 300);
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var f = focusables(); if (!f.length) return;
    var a = f[0], z = f[f.length - 1];
    if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
    else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
  }
  var closers = root.querySelectorAll('[data-spadv-close]');
  for (var c = 0; c < closers.length; c++) closers[c].addEventListener('click', close);

  // Tags für Branche und Sprache
  var form = root.querySelector('form');
  if (form) form.addEventListener('submit', function () {
    var tags = form.querySelector('[name="contact[tags]"]');
    var br = form.querySelector('[data-spadv-branche]');
    var list = (tags.value || '').split(',');
    if (br && br.value) list.push('branche-' + br.value);
    list.push(EN ? 'sprache-en' : 'sprache-de');
    tags.value = list.filter(Boolean).join(',');
  });

  if (force !== 'auto' || posted || failed) { open(); return; }
  if (store('spadv-sub')) return;
  var pause = (+root.dataset.pause || 7) * DAY;
  var x = +store('spadv-x');
  if (x && Date.now() - x < pause) return;

  var delay = (+root.dataset.delay || 8) * 1000;
  timer = setTimeout(open, delay);
  function onScroll() {
    var h = document.documentElement.scrollHeight - window.innerHeight;
    if (h > 0 && window.scrollY / h >= 0.5) { window.removeEventListener('scroll', onScroll); open(); }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  if (window.matchMedia('(pointer:fine)').matches) {
    document.addEventListener('mouseout', function onOut(e) {
      if (!e.relatedTarget && e.clientY <= 0) { document.removeEventListener('mouseout', onOut); open(); }
    });
  }
})();